import Swiper, { Pagination, Navigation, Thumbs, Controller } from 'swiper'
import eventBus from '../core/services/event-bus';
const CollectionFilter = function () {
  const slug = '/collections';

  if (window.location.href.includes(slug) ) {
    const collectionSelect = document.getElementById( 'collection-dropdown');
    if( typeof( collectionSelect ) !== 'undefined'){
      collectionSelect.addEventListener( 'change' , function( e ){
        const val = e.target.value;
        window.location.href = val;
      });
    }
  }


  // Single Product Swiper
  Swiper.use(Pagination, Navigation, Thumbs, Controller);

  const productMobile = document.querySelector('.product-mobile-swiper');
  const productDesktop = document.querySelector('.product-desktop-swiper');
  const productDesktopThumbs = document.querySelector('.product-desktop-swiper-thumbs');
  const productRelated = document.querySelector('.related-products-swiper');

  // MOBILE

    if (productMobile) {
      const nextButton = productMobile.querySelector('.swiper-button-next');
      const prevButton = productMobile.querySelector('.swiper-button-prev');
      const pagination = productMobile.querySelector('.swiper-pagination');

      let swiper = new Swiper( productMobile, {
        direction: 'horizontal',
        spaceBetween: 15,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        centeredSlides: true,
        initialSlide: 0,
        loop: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        }
      })
    }



  // THUMBS
  if (productDesktopThumbs) {
    const nextButton = productDesktopThumbs.querySelector( '.swiper-button-next');
    const prevButton = productDesktopThumbs.querySelector( '.swiper-button-prev');
    const pagination = productDesktopThumbs.querySelector( '.swiper-pagination');

    var swiperThumbs = new Swiper( productDesktopThumbs , {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesPerGroup: 1,
      slideToClickedSlide: true,
      loop: true,
      pagination: {
        el: pagination,
        clickable: true
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      }
    });
  }

// DESKTOP
  if (productDesktop) {
    var swiperDesktop = new Swiper( productDesktop , {
      direction: 'horizontal',
      slidesPerView: 1,
      slidesPerGroup: 1,
      slideToClickedSlide: true,
      loop: false,
      clickable: false,
      allowTouchMove: false
    })
  }

  if (swiperThumbs && swiperDesktop) {
    swiperThumbs.on('slideChange', function () {
      swiperDesktop.slideTo(swiperThumbs.realIndex, 400, true);
    });
      eventBus.on(eventBus.types.OptionsSelected , function( $event ){
        const variantId = $event.detail.id;
        const imageSlides = productDesktop.querySelectorAll( '.swiper-slide:not(.swiper-slide-duplicate');
        imageSlides.forEach( el => {
            const data = el.dataset;
            if( data.variantIds   ){
                if( data.variantIds.indexOf( variantId ) > -1 ){
                  swiperDesktop.slideTo( data.position , 400 );
                } 
            }
        })
    }) 
  }



  // RELATED PRODUCTS
  if ( productRelated ) {
    const nextButton = productRelated.querySelector('.swiper-button-next');
    const prevButton = productRelated.querySelector('.swiper-button-prev');
    let swiperRelated = new Swiper( productRelated , {
      direction: 'horizontal',
      spaceBetween: 15,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      centeredSlides: true,
      initialSlide: 1,
      loop: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      }
    })
  }


  $( document ).ready(function() {
    // Move related products div
      $('.product-single__related').insertBefore('#shopify-section-footer');

      // Hover state on cards
      $('.product-grid-item').on('mouseenter', function () {
        $('.product-grid-item').addClass('fade');
        $(this).addClass('full');
      });
      $('.product-grid-item').on('mouseleave', function () {
        $('.product-grid-item').removeClass('fade');
        $(this).removeClass('full');
      });
  });
}

export default CollectionFilter;
